import React, { memo } from 'react';
import { Grid, Typography } from '@mui/material';
import { slugify } from '@surfline/web-common';

import { upperCaseFirstLetter } from 'utils/string';

import styles from './TravelGuideNotes.module.scss';

interface Props {
  hazards: string;
  boardTypes: string[];
  access: string;
  bottom: string;
  bestSeason: string | undefined;
}

const TravelGuideNotes: React.FC<Props> = ({ hazards, boardTypes, access, bottom, bestSeason }) => {
  const notes = [
    {
      title: 'Hazards',
      description: hazards,
    },
    {
      title: 'Bring Your',
      description: boardTypes
        .map((board) => (board === 'SUP' ? board : upperCaseFirstLetter(board)))
        .join(', '),
    },
    {
      title: 'Access',
      description: access,
    },
    {
      title: 'Bottom',
      description: bottom,
    },
    {
      title: 'Best Season',
      description: bestSeason,
    },
  ];
  return (
    <Grid container spacing={8}>
      {notes.map(({ title, description }) => {
        if (!description) return null;
        return (
          <Grid
            key={slugify(title)}
            mobile={12}
            tablet={6}
            tabletLg={4}
            item
            className={styles.note}
            data-testid={`travel-guide-notes-${slugify(title)}`}
          >
            <Typography component="h4" variant="callout1">
              {title}
            </Typography>
            <Typography>{description}</Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default memo(TravelGuideNotes);
